// Utility for warningModalCloseHandler logic
const warningModalCloseHandlerUtil = ({
    setUsageDetailsFailureAlert,
    setShowSaveExitCompletionPopup,
    usageDetailsFailureAlert,
    usageOrderSubmission,
    isFromOrderDetailsModal,
    dispatch,
    setOrderStatus,
    getOrderSummaryData,
    setOrderSummaryModalState,
    myCaseRefId,
    history,
    fromOrdersList,
    getRoutePathWithParams,
    resetReportUsageData,
    resetReportUsageStates,
    resetNotes,
    unlockOrderFunc,
    myCaseResourceType
}) => {
    setUsageDetailsFailureAlert(false);
    setShowSaveExitCompletionPopup(false);
    if (
        usageDetailsFailureAlert ||
        (usageOrderSubmission && usageOrderSubmission?.statusCode === '200')
    ) {
        if (isFromOrderDetailsModal) {
            dispatch(setOrderStatus({ orderStatus: '' }));
            dispatch(getOrderSummaryData());
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: myCaseRefId,
                    orderSummaryModal: true,
                })
            );
        }
        history.push(
            fromOrdersList
                ? getRoutePathWithParams('/orders')
                : getRoutePathWithParams('/')
        );
        localStorage.removeItem('myCaseRefUsage');
        resetReportUsageData();
        dispatch(resetReportUsageStates());
        dispatch(resetNotes());
        (myCaseRefId && myCaseRefId?.length > 0) && unlockOrderFunc({
            action:
                myCaseResourceType === 'reportPayment'
                    ? 'ReportPayment'
                    : myCaseResourceType === 'draft'
                    ? 'DraftUsageEdit'
                    : 'ReportUsage',
            myCaseRefId: myCaseRefId,
        });
    }
};

export default warningModalCloseHandlerUtil;
